import { collection } from '../config/infoCollection'
import getDataAttributeByClassName from './getDataAttributeByClassName'
import { forOwn, includes, isEmpty } from 'lodash'

export const infoMappingByDataAttribute = (identificator, index, data_suffix) => {

  let document = getDataAttributeByClassName(identificator, index, data_suffix),
      result   = collection[document]

  returnFirstValue(result)
  return result;
}

export const infoMappingById = (identificator) => {
  let result = null
  forOwn(collection, function(value, key) {
    if ( includes(identificator, key) ) {
      result = value
      return false;
    }
  })

  if (isEmpty(result)) return returnFirstValue();
  return result;
}

const returnFirstValue = () => {
  return collection[Object.keys(collection)[0]];
}
